// extracted by mini-css-extract-plugin
export default {"statusBadge":"styles_statusBadge__6UWD-","statusContainer":"styles_statusContainer__DYHtm"};